import React from "react";

const Header1 = ({ children, style }) => {
  return <h1 style={style}>{children}</h1>;
};

export { Header1 };
